import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type {
    BulkActionResult,
    BulkMailAction,
} from "../../managers/mail/types/bulkMailAction";

export type MailCommands = {
    setReadStatus: (
        uniqueMailvistaId: string,
        isRead: boolean,
    ) => Promise<boolean>;
    setMailFocus: (
        uniqueMailvistaId: string,
        isFocus: boolean,
    ) => Promise<boolean>;
    setMailProcessed: (
        uniqueMailvistaId: string,
        isUserProcessed: boolean,
    ) => Promise<boolean>;
    deleteMail: (uniqueMailvistaId: string) => Promise<boolean>;
    executeBulkAction: (
        action: BulkMailAction,
        uniqueMailvistaIds: string[],
    ) => Promise<BulkActionResult>;
};

/** Actions sur les mails ; le SDK émet `mail-updated` / `mail-deleted` en retour. */
export function useMailCommands(): MailCommands {
    const { mailManager } = useSdk();

    return useMemo<MailCommands>(
        () => ({
            setReadStatus: (...args) => mailManager.setReadStatus(...args),
            setMailFocus: (...args) => mailManager.setMailFocus(...args),
            setMailProcessed: (...args) =>
                mailManager.setMailProcessed(...args),
            deleteMail: (...args) => mailManager.deleteMail(...args),
            executeBulkAction: (...args) =>
                mailManager.executeBulkAction(...args),
        }),
        [mailManager],
    );
}
